import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Banner from "../../components/Banner/Banner";
import TopNav from "../../components/TopNav/TopNav";
import { taxManagement } from "../../lib/topNavData";

const TaxManagement = () => {
  const location = useLocation();

  let current = location.pathname.split("/")[3];

  return (
    <>
      {current ? (
        <TopNav
          title={taxManagement[current].title}
          sub={taxManagement[current].sub}
          background={taxManagement[current].background}
        />
      ) : (
        <Banner />
      )}
      <Outlet />
    </>
  );
};

export default TaxManagement;
